import { jsx, jsxs } from 'react/jsx-runtime';
import { useCallback } from 'react';
import * as Headlessui from '@headlessui/react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';

const MenuIcon = ({ variant = 'plain', locale = {
    openOptions: 'Open options'
}, size = 16, ...props })=>{
    const adjustedSize = variant === 'circle' ? size - 8 : size;
    const handleButtonClick = useCallback((e)=>e.stopPropagation(), []);
    return jsx(Headlessui.MenuButton, {
        className: classNames('icon-button', variant),
        onClick: handleButtonClick,
        children: ({ open })=>jsxs("div", {
                className: classNames('menu-icon', {
                    open
                }),
                children: [
                    jsx("span", {
                        className: "sr-label",
                        children: locale.openOptions
                    }),
                    open ? jsx(Icon.Gradient, {
                        ...props,
                        size: adjustedSize,
                        variant: "BluePurple"
                    }) : jsx(Icon, {
                        ...props,
                        size: adjustedSize
                    })
                ]
            })
    });
};
MenuIcon.displayName = 'Menu.Icon';

export { MenuIcon };
//# sourceMappingURL=Menu.Icon.es.js.map
